import { mutator } from 'satcheljs';

import { default as setSharedSources } from '../actions/setSharedSources';
import {
    getAccountAndHostingSourceId,
    default as getAccountBySourceId,
} from '../selectors/getAccountBySourceId';

export default mutator(setSharedSources, actionMessage => {
    actionMessage.SharedAccountInfo.sources.forEach(sharedSource => {
        const accountAndHostingSource = getAccountAndHostingSourceId(sharedSource.sourceId);
        if (
            accountAndHostingSource &&
            accountAndHostingSource.hostingSourceId !== actionMessage.sourceId
        ) {
            throw new Error('Found duplicated account in the store.');
        }
    });

    const hostingAccount = getAccountBySourceId(actionMessage.sourceId);
    if (hostingAccount) {
        hostingAccount.sharedSources = actionMessage.SharedAccountInfo;
    }
});
